import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1504Model } from './kymw1504.model';
import { GetMarkGroupListService } from '../kymw1500/api-services/get-mark-group-list.service';
import { GetSupplyPromoteMarkDivListService } from '../kymw1500/api-services/get-supply-promote-mark-div-list.service';
import { GetMarkFileListService } from './api-services/get-mark-file-list.service';
import { RegistMarkFileService } from './api-services/regist-mark-file.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { RegistMarkFileVo } from './vo/regist-mark-file.model';

/**
 * マークファイル登録画面を管理するクラス
 *
 * @export KYMW1504Component
 * @class KYMW1504Component
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-kymw1504',
  templateUrl: 'kymw1504.component.html',
  styleUrls: ['kymw1504.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1504Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtg_CanRegistMarkFileList', { static: true }) dtg_CanRegistMarkFileList: FlexGrid;

  kymw1504Model: KYMW1504Model = new KYMW1504Model();

  // 親画面への連携用
  setKYMW1504Parameter: Function;

  /**
   *Creates an instance of KYMW1504Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1504Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getMarkGroupListService: GetMarkGroupListService,
    private getSupplyPromoteMarkDivListService: GetSupplyPromoteMarkDivListService,
    private getMarkFileListService: GetMarkFileListService,
    private registMarkFileService: RegistMarkFileService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1504Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1504';
    // ヘッダー行の高さ
    this.dtg_CanRegistMarkFileList.columnHeaders.rows[0].height = 52;

    this.updateMarkGroupList(() => {
      this.updateSupplyPromoteMarkDivList(() => {
        this.loadCanRegistMarkFileList();
      });
    });

    this.dtg_CanRegistMarkFileList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_CanRegistMarkFileList.select(-1, -1);
    });
  }

  /**
   * マークグループ一覧取得
   *
   * @memberof KYMW1504Component
   */
  private updateMarkGroupList(nextFunc?: Function): void {
    this.getMarkGroupListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        this.kymw1504Model.markGroupList = [];
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127', [],
          (closeDetail) => {
            // はいボタン押下時
            if (closeDetail === PlessAlert.Yes_Error) {
              this.closeFunction();
            }
          }
        );
      }
      this.kymw1504Model.updateMarkGroupListForCmb(data);
      if (nextFunc) nextFunc();
    });
  }

  /**
   * マーク区分一覧取得
   *
   * @memberof KYMW1504Component
   */
  private updateSupplyPromoteMarkDivList(nextFunc?: Function): void {
    this.getSupplyPromoteMarkDivListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        this.kymw1504Model.supplyPromoteMarkDivList = [];
        // マーク区分が取得できませんでした
        this.dialogService.openAlertGetMessage('E0128', [],
          (closeDetail) => {
            // はいボタン押下時
            if (closeDetail === PlessAlert.Yes_Error) {
              this.closeFunction();
            }
          }
        );
      }
      this.kymw1504Model.updateSupplyPromoteMarkDivListForCmb(data);
      if (nextFunc) nextFunc();
    });
  }

  /**
   * 登録可能マークファイル一覧の表示データを取得
   *
   * @memberof KYMW1504Component
   */
  public loadCanRegistMarkFileList(): void {
    this.getMarkFileListService.execute((data: any) => {
      this.kymw1504Model.updateCanRegistMarkFileList(data);
    });
  }

  /**
   * 「登録」ボタン押下イベント処理
   *
   * @memberof KYMW1504Component
   */
  public eventRegistMarkFile_CLICKHandler(): void {
    const selectedItem = this.dtg_CanRegistMarkFileList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      this.dialogService.openAlertGetMessage('E0103', ['マークファイル情報']);
      return;
    }

    // 選択されている%1を%2します。よろしいですか？
    this.dialogService.openAlertGetMessage('Q0130', ['マークファイル','登録'], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        this.registMarkFileService.execute(new RegistMarkFileVo(
          selectedItem[0].markCode,
          selectedItem[0].markCodeBranch,
        ), () => { this.loadCanRegistMarkFileList(); });
      }
    });
  }

  public eventItemSourceChangedRegistMarkThisTimeList() {
    this.kymw1504Model.canRegistMarkFileUrl = '';
  }

  /**
   * データグリッド「登録可能マークファイル一覧」クリックイベントリスナ
   */
  public eventCanRegistMarkFileList_CLICKHandler(): void {
    // プレビュー画像を表示
    this.displayImageDgtCanRegistMarkFileList();
  }

  /**
   * データグリッド「登録可能マークファイル一覧」で選択中の行に対応したプレビュー画像を表示する。
   *
   * @return true:OK false:NG
   */
  private displayImageDgtCanRegistMarkFileList(): void {
    const selectedItem = this.dtg_CanRegistMarkFileList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      // データグリッド上で行が選択されていない場合、画像を表示しない
      this.kymw1504Model.canRegistMarkFileUrl = '';
      return;
    }

    // マークファイル登録日取得
    this.kymw1504Model.canRegistMarkFileUrl = selectedItem[0].markFileUrl.toString();
  }
}
